// src/store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    clearUserInfo(state) {
      state.userInfo = null;
      localStorage.removeItem('userInfo');
    }
  },
  actions: {
    async fetchUserInfo({ commit }) {
      try {
        const response = await this.$api.get('/user/info');
        commit('setUserInfo', response.data);
      } catch (error) {
        console.error('获取用户信息失败', error);
      }
    }
  }
});

export default store;